// Note(Gavin): Need's a function until MUI fixes this issue https://github.com/mui/mui-x/issues/5454
// Solution adapted fom https://github.com/mui/material-ui/issues/29677
// Otherwise a massive amount of console errors are thrown on pages with GridToolbarContainer
export const spacing = (factor: number): string => {
  if (factor < 0) {
    return `-${spacing(-factor)}`
  }
  const values = [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60]

  let index = Math.floor(factor)
  if (index >= values.length) index = values.length - 1
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- FIXME: bulk migration to add error
  const currentSpace = values[index]!
  const nextSpace = values[index + 1] || currentSpace + 4
  const space = currentSpace + (nextSpace - currentSpace) * (factor - index)
  return `${space}px`
}
